/**
 * Balance API
 * 잔액 조회 API
 *
 * @description
 * 대시보드 상단 예치금 잔액 표시용 API
 */
import { apiClient } from '@/shared/api/client';
import type { BalanceResponse } from '../types/balance.types';
export type { BalanceResponse } from '../types/balance.types';

// ============================================================
// 상수 정의
// ============================================================
/** Balance API 기본 경로 */
const BASE_PATH = '/api/v1/balance';

// ============================================================
// API 서비스
// ============================================================
export const balanceApi = {
    /**
     * 잔액 조회
     * GET /api/v1/balance
     *
     * @returns 잔액 정보
     */
    getBalance: async (): Promise<BalanceResponse> => {
        const response = await apiClient.get<BalanceResponse>(BASE_PATH);
        return response.data;
    }
};
